import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function PaymentFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>
        Extract payment for patient or encounter from Notable databases.
      </FormHelperText>
    </Box>
  );
}
